<template>
	<v-flex xs10 offset-xs1>
		<v-card>
			<v-card-text>
				<v-text-field
					v-model="search"
					prepend-inner-icon="mdi-magnify"
					label="Поиск пользователя по имени / проекту..."
					single-line
					hide-details
					outlined
					clearable
					autofocus
				></v-text-field>
				<v-data-table
					:headers="headers"
					:items="users"
					class="elevation-1"
					:search="search"
				>
					<template v-slot:item.roles="{ item }">
						<v-chip
							v-for="(role, index) in item.roles"
							:key="role"
							:close="!~item.roles.indexOf('admin')"
							:color="!!~item.roles.indexOf('admin') ? 'primary': 'secondary'"
							@click:close="deleteUserRole(item.roles[index], item.user)"
							outlined
						>
							<v-avatar left v-if="!!~item.roles.indexOf('admin')">
								<v-icon>mdi-account-circle</v-icon>
							</v-avatar>
							{{item['rolesLabel'][index]}}
						</v-chip>
						<v-chip
							@click="appendProject(item.user)"
							v-if="!~item.roles.indexOf('admin')"
							color="secondary"
							outlined>
							<v-icon small>mdi-plus</v-icon>
						</v-chip>
					</template>
					<template v-slot:item.delete="{ item }">
						<v-icon
							small
							text
							@click="deleteUser(item.user)"
						>mdi-delete
						</v-icon>
					</template>
				</v-data-table>
				<v-btn
					block
					text
					@click="addProjectDialog = true"
				>
					Добавить нового пользователя
				</v-btn>
				<add-user-dialog
					:isOpen="addProjectDialog"
					:toggleAddUserDialog="toggleAddUserDialog"
					:projects="projects"
					:getUsers="getAllUsers"
					:toggleLoading="toggleLoading"
				></add-user-dialog>
				<add-role-user
					:isOpen="newProjectDialog"
					:user="editableUser"
					:toggleRoleUserDialog="toggleRoleUserDialog"
					:alreadyIncludedProjects="alreadyIncludedProjects"
					:getUsers="getAllUsers"
					:toggleLoading="toggleLoading"
					:projects="projects"
					:getProjects="getProjects"
				></add-role-user>
			</v-card-text>
		</v-card>
	</v-flex>
</template>

<script>
  import {AddRoleUser, AddUserDialog} from "./AdminUserPageComponents";
  import asyncQuery from "../../asyncQuery";

  export default {
    name: "AdminUserPage",
    props: {
      projects: Array,
      getProjects: Function,
      users: Array,
      getAllUsers: Function,
      toggleLoading: Function,
    },
    mounted() {
      this.getAllUsers()
    },
    data: () => {
      return {
        search: '',

        headers: [
          {text: 'Пользователь', value: 'user'},
          {text: 'Доступные проекты', value: 'roles'},
          {text: 'Удаление', value: 'delete', sortable: false, align: 'center'},
        ],

        addProjectDialog: false,

        editableUser: '',
        newProjectDialog: false,
        alreadyIncludedProjects: []
      }
    },
    methods: {
      deleteUser: function (login) {
        confirm(`Вы уверены, что хотите удалить пользователя "${login}"?`);
        asyncQuery.bind(this)({
          url: '/api/delete_user',
          method: 'POST',
          body: JSON.stringify({
            login: login,
          }),
          handleSuccess: () => this.getAllUsers(),
        })
      },
      toggleAddUserDialog: function () {
        this.$data.addProjectDialog = !this.addProjectDialog;
      },
      deleteUserRole: function (project, user) {
        confirm(`Вы уверены, что хотите удалить проект "${project}" для пользователя "${user}"?`)
        && asyncQuery.bind(this)({
          url: '/api/delete_user_role',
          method: 'POST',
          body: JSON.stringify({
            project: project,
            user: user,
          }),
          handleSuccess: () => this.getAllUsers()
        })
      },
      appendProject: function (user) {
        this.$data.editableUser = user;
        this.$data.alreadyIncludedProjects = this.users.filter(el => el.user === user)[0].roles;
        this.$data.newProjectDialog = true;
      },
      toggleRoleUserDialog: function () {
        this.$data.newProjectDialog = !this.newProjectDialog;
      },
    },
    components: {
      AddRoleUser,
      AddUserDialog,
    },
  }
</script>

<style scoped>
	.v-chip {
		margin: 2px;
	}
</style>
